import React from "react";
import * as ReactDOMServer from "react-dom/server";

import Tooltip from "../Tooltip";

export default function CellStringItemWithTooltip({ text }) {
  return (
    <>
      <span
        data-html={true}
        data-tip={ReactDOMServer.renderToString(<div>{text}</div>)}
        className="text-in-one-string"
      >
        {text}
      </span>
      <Tooltip />
    </>
  );
}
